export default __webpack_public_path__ + "assets/images/thanks-modal-stars-edc37eaf.png";